import React, { useState } from 'react';
import { Button } from './ui/button';
import ContactFormModal from './ContactFormModal';

const WhyChooseSection = () => {
  const [isContactOpen, setIsContactOpen] = useState(false);

  return (
    <>
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            {/* Left content */}
            <div className="space-y-6">
              <h2 className="text-4xl md:text-5xl font-bold leading-tight">
                <span className="text-gray-900">Email is crucial.</span>
              </h2>
              
              <h3 className="text-3xl md:text-4xl font-bold text-indigo-600">
                Because your inbox content defines your privacy
              </h3>

              <div className="space-y-4 text-gray-600 text-lg">
                <p>
                  Major email platforms like Gmail, Outlook, and Yahoo actively analyze your email content and leverage your address to build detailed profiles for targeted advertising and data monetization.
                </p>

                <p>
                  Guarded Mail Box employs military-grade end-to-end encryption with zero-knowledge architecture, ensuring that only you have access to your messages. Even our systems cannot decrypt your emails or attachments.
                </p>
              </div>

              <div className="pt-4">
                <Button 
                  onClick={() => setIsContactOpen(true)}
                  className="bg-amber-500 hover:bg-amber-600 text-white font-semibold px-8 py-6 text-lg rounded-md transition-all duration-300 hover:scale-105 hover:shadow-lg"
                >
                  SECURE YOUR EMAIL NOW
                </Button>
              </div>
            </div>

            {/* Right image */}
            <div className="relative">
              <div className="relative overflow-hidden rounded-2xl shadow-2xl group">
                <img
                  src="https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwxfHxuZXR3b3JrJTIwdGVjaG5vbG9neXxlbnwwfHx8fDE3NzQ5MTk2MTF8MA&ixlib=rb-4.1.0&q=85"
                  alt="Digital Security Network"
                  className="w-full h-auto transform transition-transform duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              </div>
              
              {/* Decorative elements */}
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-amber-500 rounded-full filter blur-2xl opacity-20 animate-pulse" style={{ animationDuration: '3s' }}></div>
              <div className="absolute -top-6 -left-6 w-24 h-24 bg-indigo-500 rounded-full filter blur-2xl opacity-20 animate-pulse" style={{ animationDuration: '4s' }}></div>
            </div>
          </div>
        </div>
      </section>

      <ContactFormModal 
        isOpen={isContactOpen} 
        onClose={() => setIsContactOpen(false)}
        title="Secure Your Email Now"
      />
    </>
  );
};

export default WhyChooseSection;